<template>
  <v-dialog v-model="dialog" width="520" scrollable>
    <category-form
      v-model="category"
      :data="currentCategory"
      :icon-list="iconList"
      :is-loading="isLoading"
      is-edit
      @submit="onUpdate"
    />
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';
import CategoryForm from './CategoryForm.vue';

export default {
  name: 'category-edit-dialog',
  components: { CategoryForm },
  mixins: [DialogBusMixin],
  props: {
    iconList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    category: null,
    isLoading: false,
    currentCategory: null,
  }),
  methods: {
    ...mapActions('categories', ['update']),
    ...mapActions(['showNotify']),

    beforeOpen({ item }) {
      this.category = null;
      this.currentCategory = item;
      this.categoryId = item.id;
    },

    async onUpdate() {
      this.isLoading = true;

      try {
        await this.update({ id: this.categoryId, ...this.category });
        this.$emit('submitted');
        this.showNotify({ message: 'Категория успешно изменена' });
        this.dialog = false;
      } catch (e) {
        this.showNotify({ type: 'error', message: 'Что-то пошло не так' });
        throw e;
      }

      this.isLoading = false;
    },
  },
};
</script>
